import ContractGrid from "components/gridTemplate/contractGrid";

export default function Agrements(subEntity: any) {
    return (<>

        <div className="ws-12 prl">
 
            <ContractGrid type="NonLanding"/>
        </div>
    </>
    )
}